// extracted by mini-css-extract-plugin
export default {"logoFull":"PulseLogo_logoFull__j+oeG","logoMark":"PulseLogo_logoMark__NfPjs","logoStamp":"PulseLogo_logoStamp__eGYG3"};